import { UploadPage } from '@luminovo/orders-ccp/upload-page';
import { createFileRoute } from '@tanstack/react-router';

import { canUploadOrders } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { LayoutCard } from '@/shared/ui/LayoutCard';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute('/_authenticated/orders/upload')({
    staticData: { access: { permissions: canUploadOrders }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <LayoutCard title={undefined} style={{ height: '100%' }}>
                <UploadPage />
            </LayoutCard>
        </SidebarPageContent>
    );
}
